import React, { useEffect } from "react";

import PageOutline from "../../components/page-outline/PageOutline";

const CustomIframe = () => {

  useEffect(() => {
    const script = document.createElement('script');

    script.src = "https://apps.elfsight.com/p/platform.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
  }, []);


  return (
    <PageOutline header={{ title: "My pinterest" }}>
   

      <div className={"elfsight-app-5ca42886-836b-4877-96d6-99af6f8b4ec9"}></div>
    </PageOutline>
  );
};

export default CustomIframe;
